export class PublicUser {
  static DISPLAY_NAME_MAX_LENGTH = 50;

  constructor(data = {}) {
    this.id = data.id || '';
    this.displayname = this.truncateDisplayName(data.displayname || '');
    this.avatarurl = data.avatarurl || '';
    this.favoriterestaurants = data.favoriterestaurants || [];
    this.trashedrestaurants = data.trashedrestaurants || [];
    this.m_mealBlockedRestaurants = new Map();

    // Parse all fields that start with 'removedformeal-'
    Object.entries(data).forEach(([key, value]) => {
      if (key.startsWith('removedformeal-')) {
        const mealId = key.replace('removedformeal-', '');
        if (Array.isArray(value)) {
          this.m_mealBlockedRestaurants.set(mealId, value);
        }
      }
    });
  }

  truncateDisplayName(name) {
    return name.length > PublicUser.DISPLAY_NAME_MAX_LENGTH 
      ? name.substring(0, PublicUser.DISPLAY_NAME_MAX_LENGTH) 
      : name;
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id;
  }

  getDisplayname() {
    return this.displayname;
  }

  setDisplayname(displayname) {
    this.displayname = this.truncateDisplayName(displayname);
  }

  getAvatarurl() {
    return this.avatarurl;
  }

  setAvatarurl(avatarurl) {
    this.avatarurl = avatarurl;
  }

  getFavoriterestaurants() {
    return this.favoriterestaurants;
  }

  setFavoriterestaurants(favoriterestaurants) {
    this.favoriterestaurants = favoriterestaurants || [];
  }

  getTrashedrestaurants() {
    return this.trashedrestaurants;
  }

  setTrashedrestaurants(trashedrestaurants) {
    this.trashedrestaurants = trashedrestaurants || [];
  }

  getBlockedrestaurants(mealId) {
    return this.m_mealBlockedRestaurants.get(mealId) || [];
  }

  setBlockedrestaurants(mealId, restaurantIds) {
    this.m_mealBlockedRestaurants.set(mealId, restaurantIds || []);
  }

  getMealBlockedRestaurants() {
    const result = {};
    this.m_mealBlockedRestaurants.forEach((restaurants, mealId) => {
      result[mealId] = [...restaurants];
    });
    return result;
  }

  setMealBlockedRestaurants(mealBlockedRestaurants) {
    this.m_mealBlockedRestaurants.clear();
    if (mealBlockedRestaurants) {
      Object.entries(mealBlockedRestaurants).forEach(([mealId, restaurants]) => {
        if (Array.isArray(restaurants)) {
          this.m_mealBlockedRestaurants.set(mealId, restaurants);
        }
      });
    }
  }

  isBlocked(mealId, restaurantId) {
    const blockedForMeal = this.getBlockedrestaurants(mealId);
    return this.trashedrestaurants.includes(restaurantId) || blockedForMeal.includes(restaurantId);
  }

  toMap() {
    return {
      id: this.id,
      displayname: this.displayname,
      avatarurl: this.avatarurl,
      favoriterestaurants: [...this.favoriterestaurants],
      trashedrestaurants: [...this.trashedrestaurants],
      m_mealBlockedRestaurants: this.getMealBlockedRestaurants()
    };
  }

  toJSON() {
    return JSON.stringify(this.toMap());
  }
} 